/**
 * Auto-generated file. Do not edit.
 * for prod
 */

export const RECAPTCHA_KEY = '6Ldt1hsbAAAAANngtfrU_XnOQ8ZDcwQLKSvzV6yF';
export const PUB_API_HOST = 'pub2.aibolit.md';
